/**
 * C2 "Welcome to {tier}." — shown only after a VERIFIED purchase from the
 * paywall (never from onboarding): in the paywall dialog when the purchase
 * resolves in place, and on `/subscription/return` after hosted checkout.
 *
 * "Improve my CV" opens the CV introduction editor, whose Spark action is the
 * app's existing AI improve entry for the introduction the card describes.
 */
import { useTranslation } from 'react-i18next';
import { NovaMood } from './NovaMood.web';
import { SparkMark } from './SparkMark.web';
import { Icon, SubButton, SubHeading } from './journey-ui.web';

/** Where "Improve my CV" goes on web (summary editor with AI enhance). */
export const IMPROVE_CV_HREF = '/(app)/cv/edit-summary';

const TIER_NAMES = { plus: 'Plus', pro: 'Pro' } as const;

export function WelcomeBody({ tier }: { tier: 'plus' | 'pro' }) {
  const { t } = useTranslation('common');
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', margin: '4px 0 16px' }}>
        <NovaMood mood="happy" size={128} />
      </div>
      <SubHeading
        center
        title={t('subscription.welcome.heading', { tier: TIER_NAMES[tier] })}
        subtitle={t('subscription.welcome.subtitle')}
      />
      <div className="tabbio-sub-card">
        <span className="tabbio-sub-mark">
          <SparkMark size={22} />
        </span>
        <h2>{t('subscription.welcome.cardTitle')}</h2>
        <p>{t('subscription.welcome.cardBody')}</p>
      </div>
    </div>
  );
}

export function WelcomeActions({
  onImprove,
  onNotNow,
}: {
  onImprove: () => void;
  onNotNow: () => void;
}) {
  const { t } = useTranslation('common');
  return (
    <>
      <SubButton onClick={onImprove} icon={<Icon name="arrow_forward" flip />}>
        {t('subscription.welcome.improveCv')}
      </SubButton>
      <SubButton kind="text" onClick={onNotNow}>
        {t('subscription.actions.notNow')}
      </SubButton>
    </>
  );
}
